<template>
  <v-dialog :value="filterForm.modalType === 'store'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển kho
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules="required"
                  name="Chuyển kho"
              >
                <v-autocomplete
                    v-model="store"
                    :items="selectedStore"
                    item-text="name"
                    item-value="value"
                    label
                    :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import {contactStatus} from "@/helpers/constants";
const ContactRepository = RepositoryFactory.get('contact');

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
    storeStocks: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      store: ''
    };
  },
  computed: {
    selectedStore() {
      return this.storeStocks.filter(item => item.value && item.value != this.filterForm.store)
    }
  },
  methods: {
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
      this.store = '';
    },
    async saveChange() {
      let changeContactList = this.contacts.filter(contact => contact.checkbox);
      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng và lựa chọn KHO cần thay đổi !!!'
        });
      }
      const existT4T5 = changeContactList.filter(contact => !this.checkConditionT4NT5ForChangeStore(_.get(contact, 'contactStatus.type', '')));

      if(existT4T5.length > 0) {
        return this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Lỗi !',
          text: 'Bạn không có quyền chuyển kho khi mối quan hệ của contact ở trạng thái T4/T5/C4/C5'
        });
      }
      //
      // let statusId = 0
      // if (this.store == 'C') {
      //   statusId = contactStatus.CO
      // } else if (this.store == 'T') {
      //   statusId = contactStatus.T0
      // } else if (this.store == 'G') {
      //   statusId = contactStatus.G0
      // } else if (this.store == 'M') {
      //   statusId = contactStatus.M0
      // }
      const dataUpdate = changeContactList.map(contact => ({
        contactId: contact.id,
        store: this.store,
        typeId: contact.typeId,
        schoolLevelId: contact.schoolLevelId
      }));
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactStore(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }

      this.$swal({
        title: 'Chuyển kho thành công!',
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
        Bus.$emit('contact-status-list');
      });
    }
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
</style>